import { useEffect, useState } from 'react';

import { sendClickLog } from '../../../utils/sendClickLog';
import { WeblogPageCategory, WeblogScreenName } from '../../../../shared/constants/weblog';
import { useDetermineMobile } from '@myrealtrip/device-detect';
import CookieManager, { CookieKey } from '../../../../shared/utils/cookieManager';

import { LangOption, LANG_OPTIONS, DEFAULT_VALUE } from '../../../../constants/languageSelect';

import DesktopSelect from './DesktopSelect';
import MobileSelect from './MobileSelect';

export default function LanguageSelector() {
  const isMobile = useDetermineMobile();
  const [selectedLang, setSelectedLang] = useState<LangOption>(DEFAULT_VALUE);

  const handleLangChange = (draftValue: LangOption) => {
    const [, domain] = window.location.hostname.split('.');

    const nextCookieValue = draftValue.value;
    CookieManager.set(CookieKey.MRT_LNG, nextCookieValue, {
      domain: `.${domain}.com`,
    });

    sendClickLog({
      eventName: 'footer',
      screenName: WeblogScreenName.COMMON,
      pageCategory: WeblogPageCategory.COMMON,
      menuTitle: '언어선택',
      selectedLanguage: nextCookieValue,
    });

    setSelectedLang(draftValue);
    window.location.reload();
  };

  useEffect(() => {
    const cookieValue = CookieManager.get(CookieKey.MRT_LNG) ?? 'ko';
    const nextValue = LANG_OPTIONS.find((option) => option.value === cookieValue) ?? DEFAULT_VALUE;

    setSelectedLang(nextValue);
  }, []);

  return (
    <>
      {isMobile && <MobileSelect onChange={handleLangChange} currentLang={selectedLang} />}
      {!isMobile && <DesktopSelect onChange={handleLangChange} currentLang={selectedLang} />}
    </>
  );
}
